module.exports = __webpack_public_path__ + "static/img/back-head.c89da598.jpg";